import React from "react";

import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { IOSSwitch } from "../../Gen/Switch";
import "./Title.css";
export const Title = ({ id, active }) => {
  const navigate = useNavigate();
  return (
    <Box className="Product">
      <Button className="ButtonProduct" onClick={() => navigate(-1)}>
        <ArrowBackIosIcon className="vector" />
        <Typography className="TopTitle">Back To Product</Typography>
      </Button>
      <Box className="ProductTitle">
        <Typography className="ProductTitle">Product #{id}</Typography>
        <Box sx={{ display: "flex", width: "250px", alignItems: "center" }}>
          <Typography className="Active">Active on Channel</Typography>
          <IOSSwitch className="statusbtn" checke={active == "1" ? true : false} sx={{ m: 1 }} defaultChecked />
        </Box>

      </Box>
    </Box>
  );
};